module.exports = __webpack_public_path__ + "img/nairobi1.82b01018.jpg";